(function (window, $) {
  'use strict';
  var document = window.document;

  var publicationsListingPagination = {
    init: function () {
      $(document).on('change', '.is_intervenant, .type_support', function (e) {
        update_publication_link();
      });

      $(document).on('click', '#page .publication_support_link', function (e) {
        e.preventDefault();
        $('.type_support').val($(this).data('support'));
        update_publication_link();
      });

      $(document).on('click', '#page .publication_cat_link', function (e) {
        e.preventDefault();
        $('.current_publication_cat').val($(this).data('cat'));
        update_publication_link();
      });

      $(document).on('click', '#page .goto_input .btn-goto-page', function (e) {
        e.preventDefault();
        var page_nb = $('#page .goto_input .publications_num_page').val();
        if (!isNaN(page_nb) && page_nb > 0) {
          update_publication_link(page_nb);
        }
      });

      //============================================
      function update_publication_link($page_nb) {
        var link = window.location.origin + window.location.pathname;
        var first_element = true;
        link = link.replace(/\/page\/.+\//, '/');
        if (!isNaN($page_nb) && $page_nb > 0) {
          link += 'page/' + $page_nb + '/';
        }

        if ($('.is_intervenant:checked').val()) {
          link += '?is_intervenant=1';
          first_element = false;
        }

        if ($('.type_support option:selected').val()) {
          if (first_element) {
            link += '?';
            first_element = false;
          } else {
            link += '&';
          }
          link += 'support=' + $('.type_support option:selected').val();
        }

        if ($('.current_publication_cat').val()) {
          link += first_element ? '?' : '&';
          link += 'cat=' + $('.current_publication_cat').val();
        }

        window.location = link;
        //$(document).trigger("_load_link", link);
      }
    },
  };

  $(document).ready(function () {
    publicationsListingPagination.init();
  });
})(window, jQuery);
